var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8a1 1 0 00-1-1H3.85l4.875-4.875A1.008 1.008 0 007.3.7L.08 7.92a.112.112 0 000 .16l7.218 7.218a.992.992 0 001.407-1.4L3.85 9H15a1 1 0 001-1z",
    fill: "#051D39"
  })));
}

export default SvgGoBack;